import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import { handleCreateInquiry, handleCreateInquiryWithUserEnteredMedication } from './actions';
import { ICreateInquiryState } from './slice.interface';

const initialState: ICreateInquiryState = {
  data: null,
  isLoading: false,
};

export const createInquirySlice = createSlice({
  name: 'create-inquiry',
  initialState,
  reducers: {
    removeCreateInquiry: state => {
      state.data = null;
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleCreateInquiry.pending, (state: ICreateInquiryState) => {
        state.isLoading = true;
      })
      .addCase(handleCreateInquiry.rejected, (state: ICreateInquiryState) => {
        state.isLoading = false;
      })
      .addCase(handleCreateInquiry.fulfilled, (state: ICreateInquiryState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        eventBus.emit(EventType.CREATE_NEW_INQUIRY_SUCCESS);
      })
      .addCase(
        handleCreateInquiryWithUserEnteredMedication.pending,
        (state: ICreateInquiryState) => {
          state.isLoading = true;
        },
      )
      .addCase(
        handleCreateInquiryWithUserEnteredMedication.rejected,
        (state: ICreateInquiryState) => {
          state.isLoading = false;
        },
      )
      .addCase(
        handleCreateInquiryWithUserEnteredMedication.fulfilled,
        (state: ICreateInquiryState, action) => {
          state.data = action.payload.data;
          state.isLoading = false;
          eventBus.emit(EventType.CREATE_NEW_INQUIRY_SUCCESS);
        },
      );
  },
});

export const { removeCreateInquiry } = createInquirySlice.actions;

export default createInquirySlice.reducer;
